import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getToken } from '_services/user-service';

// Async thunk for fetching API cache data
export const fetchApiCacheData = createAsyncThunk(
  'apiData/fetchApiCacheData',
  async (cacheId, { rejectWithValue }) => {
    try {
      const token = await getToken();
      const response = await fetch(`/api/v1/flights/schedules/feedCache/${'feed_DUB_2025-09-12T00:03:03.283Z'}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'firebase-uid': token,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  cacheData: null,
  status: 'idle', // 'idle', 'loading', 'succeeded', 'failed'
  error: null,
  cacheId: null,
};

const apiDataSlice = createSlice({
  name: 'apiData',
  initialState,
  reducers: {
    clearApiData: (state) => {
      state.cacheData = null;
      state.status = 'idle';
      state.error = null;
      state.cacheId = null;
    },
    setCacheId: (state, action) => {
      state.cacheId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApiCacheData.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchApiCacheData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.cacheData = action.payload;
        state.error = null;
      })
      .addCase(fetchApiCacheData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
        state.cacheData = null;
      });
  },
});

export const { clearApiData, setCacheId } = apiDataSlice.actions;

// Selectors
export const selectApiData = (state) => state.apiData.cacheData;
export const selectApiDataStatus = (state) => state.apiData.status;
export const selectApiDataError = (state) => state.apiData.error;
export const selectCacheId = (state) => state.apiData.cacheId;

export default apiDataSlice.reducer;
